export const SELECT_PRODUCT_TERM_LIFE = 'SELECT_PRODUCT_TERM_LIFE'

export const selectProductTermLife = (productCode) => ({
  type: SELECT_PRODUCT_TERM_LIFE,
  payload: productCode,
})

export const SELECT_BASIC_PLAN = 'SELECT_BASIC_PLAN'
export const selectBasicPlan = (product) => ({
  type: SELECT_BASIC_PLAN,
  payload: product,
})
